import { lazy } from 'react';
import { getCorrespondLabel } from '@/utils/global';
const ProjectRoutes = [
    {
        label: '',
        key: 'MainLayout',
        path: '/:templateId/:businessId',
        element: lazy(() => import('@/components/Layout/ProjectLayout')),
        needJudgeRealName: true,
        realNameType: 'project',
        children: [
            {
                label: '项目首页',
                key: 'project',
                path: 'home',
                show: true,
                element: lazy(() => import('@/page/Project/Home/Home'))
            },
            {
                label: '教学活动详情',
                key: 'teach-detail/:teachId',
                path: 'teach-detail/:teachId',
                show: true,
                element: lazy(() => import('@/page/Project/TeachDetail/TeachDetail'))
            },
            {
                label: '公告',
                key: 'notice',
                show: true,
                path: 'notice',
                element: lazy(() => import('@/page/Project/Notice/Notice'))
            },
            {
                label: '必修课',
                key: 'required-course',
                show: true,
                path: 'requiredCourse',
                element: lazy(() => import('@/page/Project/RequiredCourse/RequiredCourse'))
            },
            {
                label: '选修课',
                key: 'elective-course',
                show: true,
                path: 'electiveCourses',
                element: lazy(() => import('@/page/Project/RequiredCourse/electiveCourses'))
            },
            {
                label: '教学业务',
                key: 'teach-business',
                show: true,
                path: 'teach-business',
                element: lazy(() => import('@/page/TeachBusiness/TeachBusiness'))
            },
            {
                label: '成绩',
                key: 'score',
                show: true,
                path: 'score',
                element: lazy(() => import('@/page/Project/Score/Score'))
            },
            {
                label: '档案',
                key: 'archive',
                show: true,
                path: 'archive',
                element: lazy(() => import('@/page/Project/archive'))
            },
            {
                label: '证书',
                key: 'certificate',
                show: true,
                path: 'certificate',
                element: lazy(() => import('@/page/Project/Certificate/Certificate'))
            },
            {
                label: getCorrespondLabel('102'),
                key: 'examination-list',
                show: true,
                path: 'examination',
                element: lazy(() => import('@/page/Project/RequiredCourse/examination'))
            },
            {
                label: getCorrespondLabel('105'),
                key: 'school-assignment',
                show: true,
                path: 'schoolAssignment',
                element: lazy(() => import('@/page/Project/RequiredCourse/schoolAssignment'))
            },
            {
                label: getCorrespondLabel('106'),
                key: 'trainings-achievement',
                show: true,
                path: 'trainingAchievements',
                element: lazy(() => import('@/page/Project/RequiredCourse/trainingAchievements'))
            },
            {
                label: getCorrespondLabel('113'),
                key: 'community',
                show: true,
                path: 'community',
                element: lazy(() => import('@/page/Project/RequiredCourse/Community'))
            },
            {
                label: getCorrespondLabel('109'),
                key: 'activity',
                show: true,
                path: 'activity',
                element: lazy(() => import('@/page/Project/RequiredCourse/activity'))
            },
            {
                label: '评论',
                key: 'comment',
                show: true,
                path: 'comment',
                element: lazy(() => import('@/page/Project/MyComment').then((module) => ({ default: () => <module.default template_id={104} /> })))
            },
            {
                label: '问卷',
                key: 'survey',
                show: true,
                path: 'survey',
                element: lazy(() => import('@/page/Project/Survey/index'))
            },
            {
                label: getCorrespondLabel('202'),
                key: 'lectureHall',
                show: true,
                path: 'lectureHall',
                element: lazy(() => import('@/page/Project/RequiredCourse/lectureHall'))
            },
            {
                label: getCorrespondLabel('103'),
                key: 'liveCourse',
                show: true,
                path: 'liveCourse',
                element: lazy(() => import('@/page/Project/RequiredCourse/liveCourse'))
            }
        ]
    },
    {
        label: '档案下载',
        key: 'downArchive',
        path: '/public/:templateId/:businessId/downArchive',
        element: lazy(() => import('@/page/Project/archive/download'))
    },
    {
        label: '外链课',
        key: 'externalLinkCourse',
        path: '/externalLinkCourse',
        element: lazy(() => import('@/page/Project/RequiredCourse/components/externalLinkCourse'))
    }
];
export default ProjectRoutes;
